import React, { Component } from 'react';
import './MenuButton.css';
import * as helpers from '../helpers/helpers';
import * as htmlToImage from 'html-to-image';
import { transformWithProjections } from 'ol/proj';
import { ImMenu3, ImMenu4 } from 'react-icons/im';
import { ReactComponent as LoadMoreIcon } from './images/more.svg';

const feedbackTemplate = (
  url,
  xmin,
  xmax,
  ymin,
  ymax,
  centerx,
  centery,
  scale
) =>
  `${url}/?xmin=${xmin}&xmax=${xmax}&ymin=${ymin}&ymax=${ymax}&centerx=${centerx}&centery=${centery}&scale=${scale}`;

class MenuButton extends Component {
  state = {
    isOpen: false,
  };

  componentDidMount() {
    // CLICK ANYWHERE ELSE WILL CLOSE MENU
    document.body.addEventListener(
      'click',
      (evt) => {
        if (
          typeof evt.target.className === 'string' &&
          evt.target.className.indexOf('fs-menu-') > -1
        )
          return;

        if (this.state.isOpen) this.setState({ isOpen: !this.state.isOpen });
      },
      true
    );

    // LISTEN FOR MORE BUTTON
    window.emitter.addListener('openMoreMenu', () =>
      this.setState({ isOpen: true })
    );

    //LISTEN FOR SCREENSHOT EVENT
    window.emitter.addListener('takeScreenshot', () =>
      this.onScreenshotClick()
    );
    helpers.waitForLoad('settings', Date.now(), 30, () => {
      this.themes = this.getThemes();
      this.others = this.getOthers();
      this.tools = this.getTools();
    });
  }

  // LOAD TOOLS FROM CONFIG
  getTools = () => {
    let itemList = [];
    itemList.push(
      <MenuItem
        onClick={this.onScreenshotClick}
        key={helpers.getUID()}
        name={'Snimka ekrana'}
        iconClass={'fs-menu-screenshot-icon'}
      />
    );
    window.config.sidebarToolComponents.forEach((tool) => {
      if (
        (tool.enabled || tool.enabled === undefined) &&
        (tool.disable === false || tool.disable === undefined)
      )
        itemList.push(
          <MenuItem
            onClick={() => this.itemClick(tool.name, 'tools')}
            key={helpers.getUID()}
            name={tool.name}
            iconClass={'fs-menu-tools-icon'}
          />
        );
    });

    return itemList;
  };

  // LOAD THEMES FROM CONFIG
  getThemes = () => {
    let itemList = [];
    window.config.sidebarThemeComponents.forEach((theme) => {
      if (
        (theme.enabled || theme.enabled === undefined) &&
        (theme.disable === false || theme.disable === undefined)
      )
        itemList.push(
          <MenuItem
            onClick={() => {}}
            // onClick={() => this.itemClick(theme.name, 'themes')}
            key={helpers.getUID()}
            name={theme.name}
            iconClass={'fs-menu-theme-icon'}
          />
        );
    });
    if (
      itemList === 0 ||
      (window.config.mainSidebarItems !== undefined &&
        window.config.mainSidebarItems['hideThemes'])
    ) {
      return;
    } else {
      return itemList;
    }
  };

  // CUSTOM ENTRIES, COMMENT OUT IF YOU DON"T WANT IT
  getOthers = () => {
    let itemList = [];
    // itemList.push(
    //   <MenuItem
    //     onClick={() =>
    //       helpers.showURLWindow(
    //         window.config.whatsNewUrl,
    //         true,
    //         'full',
    //         false,
    //         true
    //       )
    //     }
    //     key={helpers.getUID()}
    //     name={"What's New"}
    //     iconClass={'fs-menu-terms-icon'}
    //   />
    // );
    // {
    //   if (!window.config.showHelpButtonInsteadOfFeedback)
    //     itemList.push(
    //       <MenuItem
    //         key={helpers.getUID()}
    //         name={'Feedback'}
    //         iconClass={'fs-menu-feedback-icon'}
    //         onClick={this.onFeedbackClick}
    //       />
    //     );
    // }
    // itemList.push(
    //   <MenuItem
    //     onClick={this.onScreenshotClick}
    //     key={helpers.getUID()}
    //     name={'Take a Screenshot'}
    //     iconClass={'fs-menu-screenshot-icon'}
    //   />
    // );
    itemList.push(
      <MenuItem
        key={helpers.getUID()}
        name={'Legenda mape'}
        iconClass={'fs-menu-legend-icon'}
        onClick={() => window.emitter.emit('openLegend', null)}
      />
    );
    // itemList.push(
    //   <MenuItem
    //     onClick={() =>
    //       helpers.showURLWindow(
    //         window.config.helpUrl,
    //         false,
    //         'full',
    //         false,
    //         true
    //       )
    //     }
    //     key={helpers.getUID()}
    //     name={'Help'}
    //     iconClass={'fs-menu-help-icon'}
    //   />
    // );
    itemList.push(
      <MenuItem
        onClick={() =>
          helpers.showURLWindow(
            window.config.termsUrl,
            false,
            'full',
            false,
            true
          )
        }
        key={helpers.getUID()}
        name={'Informacije'}
        iconClass={'fs-menu-terms-icon'}
      />
    );
    return itemList;
  };

  getMyMaps = () => {
    return (
      <MenuItem
        onClick={() => this.itemClick('mymaps', 'mymaps')}
        key={helpers.getUID()}
        name={'My Maps'}
        iconClass={'fs-menu-mymaps-icon'}
      />
    );
  };

  itemClick = (name, type) => {
    window.emitter.emit('activateSidebarItem', name, type);
    window.emitter.emit('setSidebarVisiblity', 'OPEN');
    this.setState({ isOpen: !this.state.isOpen });
  };

  onMenuButtonClick = (value) => {
    this.setState({ isOpen: !this.state.isOpen });
    helpers.addAppStat('Menu', 'Click');
  };

  getMenuClassName = () => {
    if (!this.state.isOpen) return 'fs-hidden';
    else if (window.sidebarOpen)
      return 'fs-menu-button-list-container sideBarOpen';
    else return 'fs-menu-button-list-container';
  };
  getIconToggleState = () => {
    let currentState = true;
    if (!this.state.isOpen && window.sidebarOpen) currentState = true;
    else if (this.state.isOpen && window.sidebarOpen) currentState = false;
    else if (!this.state.isOpen && !window.sidebarOpen) currentState = false;
    else if (this.state.isOpen && !window.sidebarOpen) currentState = true;
    else currentState = true;
    return currentState;
  };

  onScreenshotClick = () => {
    // console.log("MenuButton - onScreenshotClick");
    window.map.once('rendercomplete', function () {
      htmlToImage.toBlob(window.map.getTargetElement()).then(function (blob) {
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, 'map.png');
        } else {
          const elem = window.document.createElement('a');
          elem.href = window.URL.createObjectURL(blob);
          elem.download = 'map.png';
          document.body.appendChild(elem);
          elem.click();
          document.body.removeChild(elem);
        }
      });
    });

    window.map.renderSync();

    this.setState({ isOpen: false });

    // APP STATS
    helpers.addAppStat('Screenshot', 'Menu Button');
  };

  onFeedbackClick = () => {
    // APP STATS
    helpers.waitForLoad('settings', Date.now(), 30, () => {
      helpers.addAppStat('Feedback', 'Click (Footer)');

      const scale = helpers.getMapScale();
      const extent = window.map.getView().calculateExtent(window.map.getSize());
      const xmin = extent[0];
      const xmax = extent[1];
      const ymin = extent[2];
      const ymax = extent[3];
      const center = window.map.getView().getCenter();

      let feedbackUrl = feedbackTemplate(
        window.config.feedbackUrl,
        xmin,
        xmax,
        ymin,
        ymax,
        center[0],
        center[1],
        scale
      );
      if (
        window.config.mapId !== null &&
        window.config.mapId !== undefined &&
        window.config.mapId.trim() !== ''
      )
        feedbackUrl += '&MAP_ID=' + window.config.mapId;

      helpers.showURLWindow(feedbackUrl, false, 'full');
    });
  };

  render() {
    const menuListClassName = this.getMenuClassName();
    const iconToggleState = this.getIconToggleState();
    return !window.sidebarOpen ? (
      <div
        className={
          'fs-menu-button-main-container' +
          (this.props.hidden ? ' fs-hidden' : 'fs-hidden') +
          (this.props.className !== undefined && this.props.className !== ''
            ? ' ' + this.props.className
            : '')
        }
        alt="More Options"
        title="More Options"
      >
        <div
          className="fs-menu-button-container"
          style={{ cursor: 'pointer' }}
          onClick={this.onMenuButtonClick}
        >
          <button
            className="fs-menu-more-button"
            alt="More Options"
            title="More Options"
            style={{ pointerEvents: 'none' }}
          >
            <LoadMoreIcon style={{ height: '24px' }} />
          </button>
        </div>
        <div id="fs-menu-button-list-container" className={menuListClassName}>
          {window.config.mainSidebarItems !== undefined &&
          window.config.mainSidebarItems['hideThemes'] ? (
            <div></div>
          ) : (
            <div
              className="fs-menu-list-item-heading"
              style={{ paddingTop: '0px' }}
            >
              APLIKACIJE
            </div>
          )}
          {this.themes}
          <div className="fs-menu-list-item-heading">ALATI</div>
          {this.tools}
          <div className="fs-menu-list-item-heading">OSTALO</div>
          {this.others}
        </div>
      </div>
    ) : (
      <></>
    );
  }
}

export default MenuButton;

class MenuItem extends Component {
  state = {};
  render() {
    return (
      <div className="fs-menu-list-item" onClick={this.props.onClick}>
        <div className={'fs-menu-list-item-label ' + this.props.iconClass}>
          {this.props.name}
        </div>
      </div>
    );
  }
}

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg)$/)
);
function importAllImages(r) {
  let images = {};
  r.keys().map((item, index) => (images[item.replace('./', '')] = r(item)));
  return images;
}
